/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
  Image,
  Font,
  Link,
} from '@react-pdf/renderer';
import dwtcLogoImg from '../images/dwtc-logo-white.png';
import SegoeUILight from '../fonts/SegoeUI-Light.ttf';
import SegoeUISemiBold from '../fonts/SegoeUI-SemiBold.ttf';
import SegoeUIBold from '../fonts/SegoeUI-Bold.ttf';
import SegoeUIMonoRegular from '../fonts/SegoeUI-Mono-Regular.ttf';
import SegoeUIMonoBold from '../fonts/SegoeUI-Mono-Bold.ttf';
import GESSTwoBold from '../fonts/GESSTwoBold-Bold.ttf';
import GESSTwoLight from '../fonts/GESSTwoDWTC-Light.ttf';
import GESSTwoMedium from '../fonts/GESSTwoDWTC-Medium.ttf';
import GEAwtarDWTCMedium from '../fonts/GEAwtarDWTC-Medium.ttf';
import DejaVuSansMono from '../fonts/dejavu-sans-mono.bold.ttf';
import KawkabMonoRegular from '../fonts/KawkabMono-Regular.ttf';
import DINRegular from '../fonts/DIN-Regular.otf';
import { enStyles, arStyles } from './styles/DownloadCalendar.styled';
import { Button } from './styles/Button.styled';

Font.register({
  family: 'SegoeUI',
  fonts: [
    {
      fontWeight: 'thin',
      src: SegoeUILight,
    },
    {
      fontWeight: 'semibold',
      src: SegoeUISemiBold,
    },
    {
      fontWeight: 'bold',
      fontStyle: 'regular',
      src: SegoeUIBold,
    },
    {
      fontStyle: 'mono',
      fontWeight: 'normal',
      src: SegoeUIMonoRegular,
    },
    {
      fontStyle: 'mono',
      fontWeight: 'bold',
      src: SegoeUIMonoBold,
    },
  ],
});

Font.register({
  family: 'GESSTwo',
  fonts: [
    {
      fontWeight: 'thin',
      src: GESSTwoLight,
    },
    {
      fontWeight: 'semibold',
      src: GESSTwoMedium,
    },
    {
      fontWeight: 'bold',
      fontStyle: 'regular',
      src: GESSTwoBold,
    },
  ],
});

Font.register({
  family: 'DejaVuSansMono',
  fontWeight: 'bold',
  fontStyle: 'mono',
  src: DejaVuSansMono,
});

Font.register({
  family: 'DINRegular',
  src: DINRegular,
  fontWeight: 'thin',
});

Font.register({
  family: 'GEAwtarDWTCMedium',
  src: GEAwtarDWTCMedium,
  fontWeight: 'normal',
});

Font.register({
  family: 'KawkabMonoRegular',
  src: KawkabMonoRegular,
  fontWeight: 'normal',
  fontStyle: 'mono',
});

function MyDoc({ styles, title, months, monthShort, events, isArabic }) {
  function sliceString(str) {
    const bracketLeft = str.replace('(', '{');
    const bracketRight = bracketLeft.replace(')', '}');
    const strNewBracketLeft = bracketRight.replace('{', ')');
    const strNewBracketRight = strNewBracketLeft
      .replace('}', '(')
      .replace('الدورة 13', 'الدورة 31')
      .replace('ة 2023', 'ة 3202')
      .replace('ية 2023', 'ية 3202');

    if (str.length <= 60) {
      return <Text style={styles.eventTitle}>{strNewBracketRight}</Text>;
    }
    const spaceIndex = strNewBracketRight.indexOf(' ', 60);
    if (spaceIndex === -1) {
      return <Text style={styles.eventTitle}>{strNewBracketRight}</Text>;
    }
    const str2 = strNewBracketRight.slice(0, spaceIndex);
    const str3 = strNewBracketRight.slice(spaceIndex, str.length);
    return (
      <>
        <Text style={styles.eventTitle}>{str2}</Text>
        <Text style={styles.eventTitle}>{str3}</Text>
      </>
    );
  }

  const today = new Date();
  const yyyy = today.getFullYear();

  const monthsEn = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const monthsAr = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر',
  ];

  const mm = isArabic ? monthsAr[today.getMonth()] : monthsEn[today.getMonth()];
  const dd = 'DD';
  const formattedToday = `${dd} ${mm}, ${yyyy}`;

  const footerTitle = isArabic ? 'مركز دبي التجاري العالمي' : 'Dubai World Trade Centre';
  const footerPhone = isArabic ? '800DWTC هاتف: )2893(' : 'T: 800DWTC (3982)';
  const disclaimerMsg = isArabic
    ? 'الفعاليات والتواريخ قد تتغير دون إشعار مسبق'
    : 'Events and dates may change without prior notice.';
  const downloadMsg = isArabic ? 'تم إنشاؤه بتاريخ xxxx' : 'Generated as of xxxx';

  return (
    <Document style={styles.page}>
      <Page size="A3" style={styles.body} language={isArabic ? 'ar-ae' : 'en-us'}>
        <View style={styles.header}>
          <Image src={dwtcLogoImg} style={styles.headerImg} />
          <Text style={styles.headerArrow} />
          {isArabic ? (
            <View style={styles.titleContainer}>
              <Text style={styles.title}>
                {new Date().getFullYear()} - {title}
              </Text>
              <Text style={styles.subtitle}>
                {`2023 ${downloadMsg.replace(
                  'xxxx',
                  formattedToday
                    .replace(
                      'DD',
                      `${today.getDate() < 10 ? `${today.getDate()}0` : today.getDate()}`,
                    )
                    .replace(', 2023', ''),
                )}`}
              </Text>
            </View>
          ) : (
            <>
              <Text style={styles.title}>
                {title} - {today.getFullYear()}
              </Text>
              <Text style={styles.subtitle}>
                {downloadMsg.replace(
                  'xxxx',
                  formattedToday.replace(
                    'DD',
                    `${today.getDate() < 10 ? `0${today.getDate()}` : today.getDate()}`,
                  ),
                )}
              </Text>
            </>
          )}
        </View>
        {events.map((item, index) => (
          <View key={index} style={styles.container}>
            <Text style={styles.monthTitle}>{months[index]}</Text>
            {item.map((inner) => (
              <View key={inner.id} style={styles.eventContainer} wrap={false}>
                <View style={styles.dateContainer}>
                  <View style={styles.date}>
                    <Text style={styles.dateNumberText}>
                      {new Date(inner.startDate).getUTCDate() < 10
                        ? `0${new Date(inner.startDate).getUTCDate()}`
                        : new Date(inner.startDate).getUTCDate()}
                    </Text>
                    <Text style={styles.dateMonthText}>
                      {monthShort[new Date(inner.startDate).getUTCMonth()]}
                    </Text>
                  </View>
                  <View style={styles.date}>
                    <Text style={styles.dateNumberText}>
                      {new Date(inner.endDate).getUTCDate() < 10
                        ? `0${new Date(inner.endDate).getUTCDate()}`
                        : new Date(inner.endDate).getUTCDate()}
                    </Text>
                    <Text style={styles.dateMonthText}>
                      {monthShort[new Date(inner.endDate).getUTCMonth()]}
                    </Text>
                  </View>
                </View>
                <View style={styles.eventInfoContainer}>
                  {isArabic ? (
                    <Link
                      src={`https://www.dwtc.com${inner.url}`}
                      style={styles.eventInfoTitleContainer}
                    >
                      {sliceString(inner.title)}
                    </Link>
                  ) : (
                    <Link src={`https://www.dwtc.com${inner.url}`} style={styles.eventTitle}>
                      {inner.title}
                    </Link>
                  )}
                  <Text style={styles.eventTags}>
                    {inner.eventSectors.map((tag, index2) =>
                      isArabic ? (index2 ? `${tag} | ` : tag) : index2 ? ` | ${tag}` : tag,
                    )}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        ))}
        <View style={{ flexGrow: 1 }} />
        <Text style={styles.disclaimer}>{disclaimerMsg}</Text>
        <View style={styles.footerContainer}>
          <Text style={styles.footerText}>{footerTitle}</Text>
          <Link src="mailto:info@dwtc.com" style={styles.footerText}>
            info@dwtc.com
          </Link>
          <Text style={styles.footerText}>{footerPhone}</Text>
        </View>
      </Page>
    </Document>
  );
}

export default function DownloadCalendar({ dir, events }) {
  const isArabic = dir === 'rtl';
  const styles = isArabic ? arStyles : enStyles;
  const title = isArabic ? 'أجندة الفعاليات' : 'Event Calendar';

  const monthsEn = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const monthsAr = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر',
  ];

  const monthShortEn = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const months = isArabic ? monthsAr : monthsEn;
  const monthShort = isArabic ? monthsAr : monthShortEn;

  const isCurrDate = (currMonth, currYear, startDate, endDate) => {
    const currDate = +`${currYear}${currMonth < 10 ? `0${currMonth}` : currMonth}`;
    const start = +startDate.slice(0, 7).replace(/-/g, '');
    const end = +endDate.slice(0, 7).replace(/-/g, '');
    return currDate >= start && currDate <= end;
  };

  const currentDater = new Date();
  const year = currentDater.getFullYear();

  const result = [];

  for (let index = 1; index <= 12; index += 1) {
    const filtered = events.filter((event) =>
      isCurrDate(index, year, event.startDate, event.endDate),
    );
    filtered.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
    result.push(filtered);
  }

  return (
    <div style={{ transform: 'translateY(20px)' }}>
      <PDFDownloadLink
        style={{
          color: '#FFFFFF',
          fontSize: isArabic ? '16px' : '14px',
          fontFamily: isArabic ? 'GESSTwo' : 'DINMedium',
        }}
        document={
          <MyDoc
            styles={styles}
            title={title}
            months={months}
            monthShort={monthShort}
            events={result}
            isArabic={isArabic}
          />
        }
        fileName="event-calendar.pdf"
      >
        {({ loading }) =>
          loading ||
          (isArabic ? (
            <Button className="pdf-download-button-ar" stylevariant="secondary" dir="rtl">
              حمل أجندة الفعاليات
            </Button>
          ) : (
            <Button className="pdf-download-button" stylevariant="secondary" dir="ltr">
              Download Calendar
            </Button>
          ))
        }
      </PDFDownloadLink>
    </div>
  );
}
